<template lang="pug">
  article.item
    figure
      .imgwrap
        img(:src="post.featured_image_url", alt="")
      figcaption
        h2(v-html="post.title.rendered")
        .excerpt(v-html="post.excerpt.rendered")

</template>
<script>
export default {
  props: {
    post: Object
  },
  computed: {
    brTitle(){
      const ttext = this.title.trim();
      return ttext.replace(' ', '<br>')
    },
  }
}
</script>
<style lang="scss" scoped>
  .imgwrap{
    overflow: hidden;
    background-color: $maincolor;
    margin-bottom: $globalgappingx / 2;
    img{
      transition: all .3s;
      opacity: 0.8;
    }
  }
  .item{
    position: relative;
    img{
      width: 100%;
      display: block;
    }
  }
  h2{
    &::after{
      content: '';
      display: block;
      width: 60%;
      height: 20px;
      background-color: orange;
      margin-top: $globalgappingx / 4;
      margin-bottom: $globalgappingx / 4;
    }
  }

  .item{
    &:hover{
      img{
        opacity: 1;
        transform: scale(1.01);
      }
    }
  }




</style>

